import { createFileRoute } from '@tanstack/react-router';

import { CatalogV2Layout } from '~/features/catalog-v2/components/catalog-v2-layout';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';
import { requireFeatureGate } from '~/utils/guards';

/**
 * Catalog-v2 section — the new catalog screens on agentic-catalog-service, built in
 * parallel with the legacy Catalog Operations screens. The `catalog_v2` gate on this
 * layout route covers every child route; off = /access-denied. See docs/catalog-service.md.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2')({
  beforeLoad: requireFeatureGate('catalog_v2'),
  component: () => (
    <RequireChannelConnection>
      <CatalogV2Layout />
    </RequireChannelConnection>
  ),
});
